<h2 mat-dialog-title>
  Send Email Preview</h2>
<mat-dialog-content class="flex flex-col">
  <div class="flex flex-col">
    <form class="flex flex-col" [formGroup]="emailForm">
      <mat-form-field class="w-full" color="accent" appearance="outline">
        <mat-label>Subject</mat-label>
        <input matInput name="subject" formControlName="subject" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="w-full" color="accent" appearance="outline">
        <mat-label>To</mat-label>
        <input matInput name="toEmails" formControlName="toEmails" placeholder="email1@address.com, email2@address.com"
          autocomplete="off">
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<div class="flex w-full flex-row place-content-end items-end -mr-2 pb-2">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="warn" (click)="sendEmail(dialogRef, emailForm)">Send</button>
</div>